(function () {
  if (window.customElements.get('cart-discount-code')) return;

  var STORAGE_KEY = 'alshaya-discount-code';
  var FLASH_KEY = 'alshaya-discount-flash';

  function rootPath() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function sectionIdFrom(element) {
    if (!element) return null;
    var section = element.classList && element.classList.contains('shopify-section')
      ? element
      : element.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace('shopify-section-', '');
  }

  function unique(list) {
    var seen = {};
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var value = String(list[i] || '').trim();
      var key = value.toLowerCase();
      if (!value || seen[key]) continue;
      seen[key] = true;
      out.push(value);
    }
    return out;
  }

  function storeCodes(codes) {
    try {
      if (codes && codes.length) sessionStorage.setItem(STORAGE_KEY, codes.join(','));
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function setFlash(payload) {
    try {
      payload.ts = Date.now();
      sessionStorage.setItem(FLASH_KEY, JSON.stringify(payload));
    } catch (error) {}
  }

  function readFlash() {
    try {
      var raw = sessionStorage.getItem(FLASH_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > 4000) {
        sessionStorage.removeItem(FLASH_KEY);
        return null;
      }
      return data;
    } catch (error) {
      return null;
    }
  }

  function parseCodes(value) {
    if (!value) return [];
    return unique(String(value).split(','));
  }

  function codesFromCart(cart) {
    var codes = [];
    var discountCodes = cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    for (var i = 0; i < discountCodes.length; i++) {
      var item = discountCodes[i];
      if (item && item.applicable !== false && item.code) codes.push(item.code);
    }
    var applications = cart && Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    for (var j = 0; j < applications.length; j++) {
      if (applications[j] && applications[j].title) codes.push(applications[j].title);
    }
    return unique(codes);
  }

  function findCode(cart, code) {
    var discountCodes = cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    var needle = String(code || '').toLowerCase();
    for (var i = 0; i < discountCodes.length; i++) {
      if (discountCodes[i] && String(discountCodes[i].code || '').toLowerCase() === needle) {
        return discountCodes[i];
      }
    }
    return null;
  }

  function collectSectionIds(host) {
    var ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: ids }
    }));
    var cartForm = document.querySelector('.cart-form--alshaya, .cart-form');
    var cartSectionId = sectionIdFrom(cartForm);
    if (cartSectionId && ids.indexOf(cartSectionId) === -1) ids.push(cartSectionId);
    var hostSectionId = sectionIdFrom(host);
    if (hostSectionId && ids.indexOf(hostSectionId) === -1) ids.push(hostSectionId);
    return ids;
  }

  function replaceNode(current, next) {
    if (!current || !next) return;
    current.replaceWith(next);
  }

  function updateCartPage(cart) {
    var form = document.querySelector('.cart-form--alshaya, .cart-form');
    if (!form || !cart || !cart.sections) return;
    var sectionId = sectionIdFrom(form);
    var html = sectionId ? cart.sections[sectionId] : null;
    if (!html) return;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    replaceNode(form, doc.querySelector('.cart-form--alshaya, .cart-form'));
    replaceNode(
      document.querySelector('.order-summary__body'),
      doc.querySelector('.order-summary__body')
    );
    replaceNode(
      document.querySelector('.cart-header .shipping-upsell'),
      doc.querySelector('.cart-header .shipping-upsell')
    );
  }

  class CartDiscountCode extends HTMLElement {
    connectedCallback() {
      this._abort = new AbortController();
      var signal = this._abort.signal;
      var applyButton = this.querySelector('.js-cart-discount-apply, .cart-discount-code__apply');
      var input = this.querySelector('input');

      if (applyButton) {
        applyButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          this.applyCode();
        }.bind(this), { signal: signal });
      }

      if (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          event.stopPropagation();
          this.applyCode();
        }.bind(this), { signal: signal });
      }

      this.addEventListener('click', function (event) {
        var removeButton = event.target.closest('[data-discount-remove]');
        if (!removeButton || !this.contains(removeButton)) return;
        event.preventDefault();
        event.stopPropagation();
        this.removeCode(removeButton.getAttribute('data-discount-remove'));
      }.bind(this), { signal: signal });

      var flash = readFlash();
      if (flash && flash.message) this.showStatus(flash.message, !!flash.error);
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
    }

    currentCodes() {
      return parseCodes(this.getAttribute('data-applied-codes'));
    }

    showStatus(message, isError) {
      var status = this.querySelector('.js-cart-discount-status, .cart-discount-code__status');
      if (!status) return;
      status.hidden = !message;
      status.textContent = message || '';
      status.classList.toggle('is-error', !!isError);
    }

    setBusy(isBusy) {
      var applyButton = this.querySelector('.js-cart-discount-apply, .cart-discount-code__apply');
      var removeButtons = this.querySelectorAll('[data-discount-remove]');
      if (applyButton) {
        applyButton.disabled = !!isBusy;
        if (isBusy) applyButton.setAttribute('aria-busy', 'true');
        else applyButton.removeAttribute('aria-busy');
      }
      for (var i = 0; i < removeButtons.length; i++) {
        removeButtons[i].disabled = !!isBusy;
      }
    }

    applyCode() {
      var input = this.querySelector('input');
      var code = input && input.value ? input.value.trim() : '';
      if (!code) {
        this.showStatus(this.getAttribute('data-empty-error') || 'Please enter a discount code', true);
        if (input) input.focus();
        return;
      }
      this.updateCodes(unique(this.currentCodes().concat([code])), code, 'apply');
    }

    removeCode(code) {
      var remaining = this.currentCodes().filter(function (item) {
        return item.toLowerCase() !== String(code || '').toLowerCase();
      });
      this.updateCodes(remaining, code, 'remove');
    }

    async updateCodes(nextCodes, changedCode, action) {
      this.setBusy(true);
      this.showStatus('', false);

      try {
        var sectionIds = collectSectionIds(this);
        var response = await fetch(rootPath() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            discount: nextCodes.join(','),
            sections: sectionIds
          })
        });
        var cart = await response.json();
        if (!response.ok) {
          throw new Error(cart.description || cart.message || this.getAttribute('data-invalid-error'));
        }

        if (action === 'apply') {
          var match = findCode(cart, changedCode);
          if (match && match.applicable === false) {
            this.showStatus(this.getAttribute('data-invalid-error') || 'This discount code is invalid', true);
            return;
          }
          var appliedNow = codesFromCart(cart);
          var isApplied = appliedNow.some(function (item) {
            return item.toLowerCase() === String(changedCode || '').toLowerCase();
          });
          if (!isApplied && Array.isArray(cart.discount_codes)) {
            this.showStatus(this.getAttribute('data-invalid-error') || 'This discount code is invalid', true);
            return;
          }
        }

        var applied = codesFromCart(cart);
        storeCodes(applied);
        setFlash({
          message: action === 'remove'
            ? (this.getAttribute('data-removed-message') || 'Discount code removed')
            : (this.getAttribute('data-applied-message') || 'Discount code applied'),
          error: false
        });

        if (cart.sections) {
          var drawer = document.querySelector('cart-drawer');
          var drawerSectionId = sectionIdFrom(drawer);
          if (!drawer || !drawerSectionId || cart.sections[drawerSectionId]) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'discount:change',
                cart: cart
              }
            }));
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          updateCartPage(cart);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      } catch (error) {
        this.showStatus((error && error.message) || this.getAttribute('data-invalid-error'), true);
      } finally {
        this.setBusy(false);
      }
    }
  }

  window.customElements.define('cart-discount-code', CartDiscountCode);
})();
